// extracted by mini-css-extract-plugin
export default {"fields":"pSihbP","time":"spIJMX","mobile":"R06B4W"};